<template>
  <div
    :key="$route.fullPath"
    class="wrap"
  >
    <div
      v-if="!loaded"
      class="wrap--loading"
    />

    <div
      v-else
      key="PDF"
    >
      <div class="pdf">
        <LayoutResourceHeader
          :title="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.title ? results.pdf.byId[selectedHash].attributes.title : 'Unknown'"
          type="pdfs"
          logo='<svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24"><path d="M8.847 17.875c.191-.211.548-.431.801-.559-.152.3-.366.619-.544.792-.36.353-.556.095-.257-.233zm7.062-12.098c2.047-.478 4.805.28 6.091 1.179-1.494-1.997-5.23-5.708-7.432-6.882 1.156 1.168 1.563 4.235 1.341 5.703zm-4.769 10.21c.328-.109 1.036-.274 1.213-.315-.02-.021-.528-.544-.695-.832-.134.335-.509 1.127-.518 1.147zm.64-4.008c-.057-.278-.263-.299-.326.024-.057.296.029.771.129 1.061.113-.237.255-.805.197-1.085zm10.22-.979v13h-20v-24h8.409c4.857 0 3.335 8 3.335 8 3.009-.745 8.256-.42 8.256 3zm-6.98 4.413c-.526-.077-1.272.009-1.797.093-.385-.325-.866-.817-1.233-1.472.253-.652.415-1.168.483-1.536.354-1.919-1.979-2.072-1.729-.012.066.549.222 1.082.464 1.588-.286.709-.651 1.508-1.018 2.232-.811.307-1.396.627-1.742.954-1.212 1.143.295 2.661 1.438 1.014.274-.395.581-.955.811-1.396.717-.253 1.551-.475 2.33-.618.509.39 1.322.896 1.972.896 1.239.001 1.417-1.538.021-1.743zm-.104.704c-.2-.03-.488-.03-.829-.002.235.158.558.323.911.33.412.008.377-.26-.082-.328z"/></svg>'
          :topics="[results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.topics[0] ? results.pdf.byId[selectedHash].attributes.topics[0].id : '']"
          :resourceId="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].id ? results.pdf.byId[selectedHash].id : '#'"
          :licensed="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.licensed === true && results.pdf.byId[selectedHash].attributes.trial === false ? true : false"
          :trial="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.trial === true && results.pdf.byId[selectedHash].attributes.trial === false ? true : false"
          :free="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.free === true && results.pdf.byId[selectedHash].attributes.free === false ? true : false"
          :viewed="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.viewed ? results.pdf.byId[selectedHash].attributes.viewed : false"
          :downloaded="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.downloaded ? results.pdf.byId[selectedHash].attributes.downloaded : false"
          :filterWords="filterWords"
          :comingFrom="comingFrom"
        />

        <div class="pdf__view">
          <div
            class="pdf__controls"
            id="pdf__controls"
          >
            <LayoutFilterControls
              type="pdf"
              :selectedTopic="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.topics ? results.pdf.byId[selectedHash].attributes.topics[0] : false"
              :selectedLocation="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.locations ? results.pdf.byId[selectedHash].attributes.locations[0] : false"
              :selectedTradeType="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.trade_types ? results.pdf.byId[selectedHash].attributes.trade_types[0] : false"
              :selectedScale="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.scales ? results.pdf.byId[selectedHash].attributes.scales[0] : false"
            />
          </div>

          <div class="pdf__downloadWrap">
            <div class="pdf__download">
              <p v-if="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.licensed === true && results.pdf.byId[selectedHash].attributes.trial === false">You have full access to this market report.<br />Click the button below to start downloading.</p>
              <p v-else>
                <template v-if="isAuthenticated">
                  This market report is not licensed for download.<br />You can <a href="https://statzon.com/pricing" target="_blank" class="link">unlock</a> this report with Statzon subscription.
                </template>

                <template v-else>
                  You need active subscription to download market reports.<br />If you have already subscribed <router-link to="/login" class="link">click here</router-link> to login.
                </template>
              </p>

              <FormSubmit
                v-if="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.licensed === true && results.pdf.byId[selectedHash].attributes.trial === false"
                :status="downloadStatus"
                :disabled="false"
                icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M9 3h6v2h-6v-2zm3 15l7-8h-4v-4h-6v4h-4l7 8zm3-16v-2h-6v2h6zm3.213-.246l-1.213 1.599c2.984 1.732 5 4.955 5 8.647 0 5.514-4.486 10-10 10s-10-4.486-10-10c0-3.692 2.016-6.915 5-8.647l-1.213-1.599c-3.465 2.103-5.787 5.897-5.787 10.246 0 6.627 5.373 12 12 12s12-5.373 12-12c0-4.349-2.322-8.143-5.787-10.246z"/></svg>'
                @click="downloadPDF()"
              >
                {{ downloadStatus === 'success' ? 'Thank you!' : 'Download PDF' }}
              </FormSubmit>

              <FormSubmit
                v-else
                :status="requestStatus"
                :disabled="requestStatus === 'success' ? true : false"
                icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M9 3h6v2h-6v-2zm3 15l7-8h-4v-4h-6v4h-4l7 8zm3-16v-2h-6v2h6zm3.213-.246l-1.213 1.599c2.984 1.732 5 4.955 5 8.647 0 5.514-4.486 10-10 10s-10-4.486-10-10c0-3.692 2.016-6.915 5-8.647l-1.213-1.599c-3.465 2.103-5.787 5.897-5.787 10.246 0 6.627 5.373 12 12 12s12-5.373 12-12c0-4.349-2.322-8.143-5.787-10.246z"/></svg>'
                @click="requestAccess()"
              >
                {{ requestStatus === 'success' ? 'We will be in touch!' : 'Request Access' }}
              </FormSubmit>
            </div>
          </div>

          <div class="pdf__content">
            <LayoutResourceInfo
              :resource="results && results.pdf && results.pdf.byId[selectedHash] ? results.pdf.byId[selectedHash] : false"
              :source="source"
              :originallyPublished="originallyPublished"
              :loading="loading.pdfPdf"
              :timeout="timeout.pdfPdf"
              :noResults="noResults.pdfPdf"
            />

            <UtilityTabs>
              <UtilityTab
                key="PDF_TAB__0"
                label="Data Provider"
                :index="0"
                :selected="tabIndex"
                :disabled="false"
                @tabChanged="changeTab"
              />

              <UtilityTab
                v-for="tab in tabs"
                :key="'PDF_TAB__' + tab.index"
                :label="tab.label"
                :index="tab.index"
                :selected="tabIndex"
                :disabled="tab.disabled"
                @tabChanged="changeTab"
              />
            </UtilityTabs>

            <UtilityTabPanel :index="0" :selected="tabIndex">
              <LayoutDataProvider
                :id="results && results.pdf && results.pdf.byId[selectedHash] ? results.pdf.byId[selectedHash].attributes.providers[0].id : false"
                :name="results && results.pdf && results.pdf.byId[selectedHash] ? results.pdf.byId[selectedHash].attributes.providers[0].attributes.name : false"
                :website="results && results.pdf && results.pdf.byId[selectedHash] ? results.pdf.byId[selectedHash].attributes.providers[0].attributes.website : false"
                :description="results && results.pdf && results.pdf.byId[selectedHash] ? results.pdf.byId[selectedHash].attributes.providers[0].attributes.description : false"
              />
            </UtilityTabPanel>

            <UtilityTabPanel
              v-for="tab in tabs"
              :index=tab.index
              :selected=tabIndex
            >
              <div
                v-if="tab.content"
                v-html="highlight(links(tab.content), filterWords)"
                :class="tab.index === 'ai_summary' ? 'ai_summary' : ''"
              />
              <div
                v-else
                v-html="tab.label + ' is not available.'"
              />
            </UtilityTabPanel>
          </div>
        </div>

        <div class="pdf__meta">
          <AppPDFs
            key="PDF_TOPICS"
            type="related"
            sliderName="pdf_topics"
            identifier="pdfTopics"
            :title="windowWidth < 960 ? 'Reports with topic' : 'More reports with topic'"
            :subtitle="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.topics[0] ? results.pdf.byId[selectedHash].attributes.topics[0].attributes.name : false"
            display="slider"
            :selectedResultId="selectedId"
            :results="results.pdfTopics"
            :paginator="meta.pdfTopics.paginator"
            :loading="loading.pdfTopics"
            :timeout="timeout.pdfTopics"
            :noResults="noResults.pdfTopics"
            @itemClicked="itemClicked"
            @controlsChanged="toggleControls"
          />

          <AppPDFs
            key="PDF_PROVIDERS"
            type="related"
            sliderName="pdf_providers"
            identifier="pdfProviders"
            :title="windowWidth < 960 ? 'Reports from' : 'More reports from'"
            :subtitle="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.providers[0] ? results.pdf.byId[selectedHash].attributes.providers[0].attributes.name : false"
            subtitleColor="pink"
            display="slider"
            :selectedResultId="selectedId"
            :results="results.pdfProviders"
            :paginator="meta.pdfProviders.paginator"
            :loading="loading.pdfProviders"
            :timeout="timeout.pdfProviders"
            :noResults="noResults.pdfProviders"
            @itemClicked="itemClicked"
            @controlsChanged="toggleControls"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadPost } from '@/helpers/http'
import AppPDFs from '@/components/app/PDFs.vue'
import FormSubmit from '@/components/form/Submit.vue'
import LayoutResourceHeader from '@/components/layout/ResourceHeader.vue'
import LayoutFilterControls from '@/components/layout/FilterControls.vue'
import LayoutResourceInfo from '@/components/layout/ResourceInfo.vue'
import LayoutDataProvider from '@/components/layout/DataProvider.vue'
import UtilityTabs from '@/components/utility/Tabs.vue'
import UtilityTab from '@/components/utility/Tab.vue'
import UtilityTabPanel from '@/components/utility/TabPanel.vue'
import helperMethods from '@/helpers/utility.js'

export default {
  components: {
    AppPDFs,
    FormSubmit,
    LayoutResourceHeader,
    LayoutFilterControls,
    LayoutResourceInfo,
    LayoutDataProvider,
    UtilityTabs,
    UtilityTab,
    UtilityTabPanel
  },
  metaInfo () {
    if (this.results && this.results.pdf && this.results.pdf.byId[this.selectedHash] && this.results.pdf.byId[this.selectedHash].attributes) {
      return {
        title: this.results.pdf.byId[this.selectedHash].attributes.title,
        meta: [
          {
            name: 'description',
            content: '' // Not available anymore, redo these
          }
        ]
      }
    }
    return {}
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      tabIndex: 0,
      loaded: false,
      loading: {
        pdfTopics: true,
        pdfProviders: true
      },
      timeout: {
        pdfTopics: false,
        pdfProviders: false
      },
      noResults: {
        pdfTopics: false,
        pdfProviders: false
      },
      url: {
        pdfTopics: false,
        pdfProviders: false
      },
      comingFrom: false,
      downloadStatus: 'default',
      requestStatus: 'default',
      panelSuccess: false
    }
  },
  computed: {
    selectedHash () {
      return this.$store.getters['search/getSelectedHash']
    },
    selectedId () {
      return this.$store.getters['search/getSelectedId']
    },
    results () {
      return this.$store.getters['search/getResults']
    },
    searchToken () {
      return this.$store.getters['search/getSearchToken']
    },
    input () {
      return this.$store.getters['search/getInput']
    },
    meta () {
      return this.$store.getters['search/getMeta']
    },
    requestingAccess () {
      return this.$store.getters['app/getRequestingAccess']
    },
    resourcePath () {
      if (this.$route.path) {
        return this.$route.path
      }

      return ''
    },
    filterWords () {
      let words = []
      let getter = this.$store.getters['search/getSelectedFilters']
      Object.keys(getter).forEach(function (filters) {
        if (getter[filters] && getter[filters].length > 0) {
          getter[filters].forEach(function (filter) {
            words.push(filter.attributes.name)
          })
        }
      })
      return words
    },
    tabs () {
      let tabs = []
      let tabItems = this.results && this.results.pdf && this.results.pdf.byId[this.selectedHash] && this.results.pdf.byId[this.selectedHash].attributes.meta ? this.results.pdf.byId[this.selectedHash].attributes.meta : false
      let prioritized = ['description', 'table of contents', 'list of tables', 'list of figures']
      let ignored = ['description', 'table of contents', 'list of tables', 'list of figures', 'source', 'publish date', 'report\'s original publish date']

      let aiSummary = this.results && this.results.pdf && this.results.pdf.byId[this.selectedHash] && this.results.pdf.byId[this.selectedHash].attributes.ai_summary ? this.results.pdf.byId[this.selectedHash].attributes.ai_summary : false

      if (aiSummary && aiSummary !== '') {
        tabs.push({
          'index': 'ai_summary',
          'label': 'AI generated summary',
          'content': '<span><i>This summary is AI-generated. AI can make mistakes. We recommend checking the original report.</i></span><br />' + aiSummary,
          'disabled': false
        })
      }

      if (tabItems) {
        let index = 1
        tabItems = Object.entries(JSON.parse(tabItems))

        for (const [key, value] of tabItems) {
          if (prioritized.includes(key.toLowerCase())) {
            let tabItem = {
              'index': index,
              'label': key,
              'content': value,
              'disabled': false
            }

            tabs.push(tabItem)
            index++
          }
        }

        for (const [key, value] of tabItems) {
          if (!ignored.includes(key.toLowerCase())) {
            let tabItem = {
              'index': index,
              'label': key,
              'content': value,
              'disabled': false
            }

            tabs.push(tabItem)
            index++
          }
        }
      }

      return tabs
    },
    source () {
      let source = false
      let metaItems = this.results && this.results.pdf && this.results.pdf.byId[this.selectedHash] && this.results.pdf.byId[this.selectedHash].attributes.meta ? this.results.pdf.byId[this.selectedHash].attributes.meta : false

      for (const [key, value] of Object.entries(JSON.parse(metaItems))) {
        if (['source'].includes(key.toLowerCase())) {
          source = value
        }
      }

      return source
    },
    originallyPublished () {
      let published = false
      let metaItems = this.results && this.results.pdf && this.results.pdf.byId[this.selectedHash] && this.results.pdf.byId[this.selectedHash].attributes.meta ? this.results.pdf.byId[this.selectedHash].attributes.meta : false

      for (const [key, value] of Object.entries(JSON.parse(metaItems))) {
        if (['publish date', 'report\'s original publish date'].includes(key.toLowerCase())) {
          published = value
        }
      }

      return published
    },
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    }
  },
  methods: {
    search (type, view, url) {
      this.$store.dispatch('search/setSearchToken', { 'type': view, 'url': url })
      url = url + 'search_token=' + this.searchToken[view]

      if (!this.results[type] || this.searchToken[view] !== this.meta[type].parameters.search_token) {
        this.$store.dispatch('search/fetchResults', { 'type': type, 'view': view, 'url': url, preventGa: true }).then(response => {
          let checkResults = this.results[type]
          this.loading[type] = false

          if (checkResults.allIds.length === 0) {
            this.noResults[type] = true
            this.timeout[type] = false
          } else {
            this.noResults[type] = false
            this.timeout[type] = false
          }

          return true
        }).catch(error => {
          this.timeout[type] = true
          this.loading[type] = false
        })
      } else {
        this.noResults[type] = false
        this.timeout[type] = false
        this.loading[type] = false
      }

      return false
    },
    requestAccess () {
      this.sendGoogleAnalyticsEvent('access_pre_request', this.resourcePath, false, this.$store.getters['user/getSubscriptionStatus'])
      this.$store.dispatch('app/setRequestingAccess', !this.requestingAccess)
    },
    downloadPDF () {
      this.downloadStatus = 'loading'
      let parameters = {
        pdfs: [this.selectedId]
      }

      downloadPost('downloads/pdf', parameters).then(response => {
        let blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        let fileName = this.results.pdf.byId[this.selectedHash].attributes.title.replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '').toLowerCase().substring(0, 128) + '.pdf'
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.sendGoogleAnalyticsEvent('download_pdfs_file', this.$store.getters['search/getResults'].pdf.byId[this.$store.getters['search/getSelectedHash']].attributes.title, false, this.$store.getters['user/getSubscriptionStatus'])
        this.downloadStatus = 'success'
      }).catch(error => {
        this.excelError = error.errors
        this.downloadStatus = 'default'
      })
    },
    close () {
      let searchView = this.comingFrom === 'PDFs' ? 'pdfs' : 'search'

      this.unselectedImageLabels = []
      this.$store.dispatch('app/setSettings', { 'name': 'search.view', 'value': searchView })

      if (searchView === 'search') {
        this.$router.push('/search?' + this.$store.getters['search/getFiltersQuery'](false, false))
      } else {
        this.$router.push('/pdfs?' + this.$store.getters['search/getFiltersQuery'](false, false) + this.$store.getters['search/getControlsQuery']('pdfs', 'client'))
      }
    },
    forwardTo (location) {
      if (location === 'https://statzon.com/contact-us') {
        window.open(location, '_blank')
      } else {
        this.$router.push(location)
      }
    },
    itemClicked (value) {
      if (value.type !== 'news') {
        this.$store.dispatch('search/setSelectedView', value.type)
        this.$store.dispatch('search/setSelectedId', value.id)
        this.$store.dispatch('search/setSelectedHash', value.hash)
        this.$router.push('/'+ value.type + '/' + value.id)
      }
    },
    toggleControls (setting, value) {
      if (setting !== 'pdf.download') {
        this.$store.dispatch('app/setSettings', { 'name': setting, 'value': value })
      }

      if (setting === 'pdf.download') {
        if (value === 'xls') {
          this.downloadExcel()
        } else if (value === 'img') {
          this.downloadImage()
        }
      }

      if (setting === 'search.view') {
        if (['pdfTopics', 'pdfProviders'].includes(value)) {
          let url = value === 'pdfTopics' ? this.url['pdfTopics'] : this.url['pdfProviders']
          this.$router.push('/pdfs?' + url)
        }
      }
    },
    resetResults () {
      let resetResults = this.$store.getters['search/getResults']
      delete resetResults.pdfTopics
      delete resetResults.pdfProviders

      this.loading = {
        pdfTopics: true,
        pdfProviders: true
      }

      this.$store.dispatch('search/setResults', resetResults)
    },
    async init () {
      let pdfId = this.$route.params.id
      let pdfHash = 'PDF_' + pdfId

      this.$store.dispatch('app/setSettings', { 'name': 'search.view', 'value': 'pdf' })
      this.$store.dispatch('search/setSelectedId', pdfId)
      this.$store.dispatch('search/setSelectedHash', pdfHash)
      this.$store.dispatch('search/setSelectedView', 'pdf')
      this.$store.dispatch('search/logView', pdfHash)

      if(!(this.results && this.results.pdf && this.results.pdf.byId[pdfHash])) {
        let newResult = false

        if (this.results && this.results.pdfs && this.results.pdfs.byId[pdfHash]) {
          newResult = this.results.pdfs.byId[pdfHash]
        } else if (this.results && this.results.pdfProviders && this.results.pdfProviders.byId[pdfHash]) {
          // TODO: This is not working, its never found for some reason...
          // Upper one works sometimes when actual search results (datasets) are same as datasetDatasets (coming from search, not F5)
          newResult = this.results.pdfProviders.byId[pdfHash]
        }

        if (newResult !== false) {
          let normalizedResults = this.$store.getters['search/getResults']

          normalizedResults.pdf = {
            'byId': { [pdfHash]: this.results.pdfs.byId[pdfHash] },
            'allIds': [pdfHash]
          }

          this.$store.dispatch('search/setResults', normalizedResults)
        } else {
          await this.$store.dispatch('search/fetchPDF', pdfId)
        }
      }

      this.loaded = true
      let result = this.results.pdf.byId[pdfHash]

      if (pdfId !== this.results.pdf.byId[this.results.pdf.allIds[0]].id) {
        pdfId = this.results.pdf.byId[this.results.pdf.allIds[0]].id
        this.$router.push({ path: pdfId})
      }

      // SEO Title and description
      document.title = result.attributes.title;
      /*if (result.attributes.description && result.attributes.description !== '') {
        document.querySelector('meta[name="description"]').setAttribute("content", result.attributes.description);
      } else*/ if (result.attributes.topics && result.attributes.topics.length > 0) {
        document.querySelector('meta[name="description"]').setAttribute("content", 'Gain market insights about ' + result.attributes.topics[0].attributes.name);
      }

      this.url.pdfTopics = 'topics=' + result.attributes.topics[0].id + '&sort=relevance&page=1&mode=related&'
      this.url.pdfProviders = 'providers=' + result.attributes.providers[0].id + '&sort=-published&page=1&mode=related&'

      this.search('pdfTopics', 'pdfTopics', 'pdfs?' + this.url.pdfTopics)
      this.search('pdfProviders', 'pdfProviders', 'pdfs?' + this.url.pdfProviders)
    },
    changeTab (value) {
      this.tabIndex = value
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    ...helperMethods
  },
  watch: {
    $route (to, from) {
      this.loaded = false
      this.comingFrom = from.name
      this.resetResults()
      this.init()
    }
    /*isAuthenticated: function (per, current) {
      let response = this.$store.dispatch('search/fetchResults')
      if (response) {
        let that = this
        this.$nextTick(function () {
          that.refreshKey = '_' + Math.random().toString(36).substr(2, 9)
        })
      }
    }*/
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.comingFrom = from.name
    })
  },
  mounted () {
    this.resetResults()
    this.init()

    let that = this
    document.addEventListener('keyup', function (event) {
      if (event.keyCode === 27) {
        that.close()
      }
    })

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.nextItem)
    window.removeEventListener('resize', this.nextItem)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.wrap {
  width: 100%;
  max-width: $xlContentWidth;
  height: auto;
  margin: 144px auto 64px auto;

  @media screen and (min-width: $breakpointSm) {
    width: calc(100% - 32px);
    margin: 100px auto 464px auto;
  }

  @media screen and (min-width: $breakpointLg) {
    margin: 108px auto 464px auto;
  }

  &--loading {
    height: 100vh;
  }
}

.pdf {
  @include font('content--md', $white, 0.9);
  width: calc(100% - 2px);
  border-width: 1px;
  border-style: solid;
  border-color: $black;
  background-color: $bg-4;
  box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  position: relative;
  //padding-bottom: 3rem;

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg');
  }

  &__metadata {
    //background-color: $bg-4;
    //padding: 16px;
    //position: relative;
    white-space: pre-wrap;
    //border-top: 1px solid $black;
    //border-bottom: 1px solid $black;
  }

  &__meta {
    width: 100%;
    //white-space: pre-wrap;
    //height: auto;
  }

  &__view {
    position: relative;
    z-index: 20;
    border-top: 1px solid rgba($white, 0.1);
    background-color: $bg-4;
  }

  &__content {
    border-bottom: 1px solid $black;
  }

  &__controls {
    display: flex;
    justify-content: space-between;
    background-color: $bg-4;
    border-bottom: 1px solid $black;
    height: 36px;

    @media screen and (min-width: $breakpointLg) {
      height: 40px;
    }
  }

  &__downloadWrap {
    background-color: $bg-2;
    background-image: url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23272b2f' fill-opacity='0.8' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E");
    border-top: 1px solid rgba($white, 0.1);
    padding: 3rem 0;
  }

  &__download {
    background-color: $bg-4;
    width: calc(100% - 2rem - 18px);
    max-width: 480px;
    margin: 0 auto;
    padding: 1.5rem 1rem 2rem 1rem;
    border-radius: 6px;
    border: 2px solid $bg-1;
    text-align: center;

    @media screen and (min-width: $breakpointLg) {
      max-width: 520px;
    }

    p {
      margin: 0 1rem 1.5rem 1rem;
      color: rgba($white, 0.7);
    }
  }

  &__panel {
    overflow: auto;
    position: absolute;
    top: 0px;
    z-index: 90;
    width: 100%;
    max-width: 540px;

    @media screen and (min-width: 540px) {
      //top: 16px;
      left: calc(50% - 270px);
    }

    &--success {
      overflow: visible;
    }
  }
}

.ai_summary {
  white-space: normal;
}

</style>
